module.exports = __webpack_public_path__ + "media/custom/images/img27-0f39a68c886416b697ea6a9c75fee8e4.png";